import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

const transportTypes = async function (input) {
  console.log('TCL: input', input)
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input
    }
    const res = await axios.get(urls.transportTypeList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const locations = async function (input) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input
    }
    const res = await axios.get(urls.locationList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const customers = async function (input) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
      type: 'SHIPPER'
    }
    let res = await axios.get(urls.clientList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch location according active orders
 * @param {String} input user input search text
 * @param {String} type locationtype; destination/origin
 */
const availableLocationsFromOrders = async function (input, type) {
  try {
    let filters = {
      page: 0,
      size: 10,
      name: input,
      type
    }
    const url = urls.locationsFromOrders + '?' + querystring.stringify(filters)
    console.log('availableLocationsFromOrders -> url', url)
    const res = await axios.get(url)
    console.log('availableLocationsFromOrders -> res.data', res.data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch transport available for order filter
 * @param {String} input transport input search text
 */
const availableVehiclesFromOrders = async function (input) {
  try {
    let filters = {
      page: 0,
      size: 10,
      no: input,
    }
    const url = urls.vehiclesFromOrders + '?' + querystring.stringify(filters)
    const res = await axios.get(url)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  transportTypes,
  locations,
  availableLocationsFromOrders,
  customers,
  availableVehiclesFromOrders,
}
